import React, { Component } from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@material-ui/core';

class LayerDataTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      layers: [
        { id: 1, name: 'Leire 1', bottom: 0, top: 10, strength: 'High', frictionAngle: 30 },
        { id: 2, name: 'Sand 1', bottom: 10, top: 20, strength: 'Medium', frictionAngle: 25 },
        { id: 3, name: 'Silt 1', bottom: 20, top: 30, strength: 'Low', frictionAngle: 20 },
      ],
    };
  }

  handleInputChange = (event, id, field) => {
    const { value } = event.target;
    this.setState((prevState) => {
      const updatedLayers = prevState.layers.map((layer) => {
        if (layer.id === id) {
          return { ...layer, [field]: value };
        }
        return layer;
      });

      return { layers: updatedLayers };
    });
  };

  render() {
    const { layers } = this.state;

    return (
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Navn</TableCell>
              <TableCell>Lag bunn (m)</TableCell>
              <TableCell>Lag topp (m)</TableCell>
              <TableCell>C-profil</TableCell>
              <TableCell>Su[kPa]</TableCell>
              <TableCell>Friksjonsvinkel</TableCell>
              <TableCell>E-modul</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {layers.map((layer) => (
              <TableRow key={layer.id}>
                <TableCell>
                  <TextField
                    value={layer.name}
                    onChange={(event) => this.handleInputChange(event, layer.id, 'name')}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    type="number"
                    value={layer.bottom}
                    onChange={(event) => this.handleInputChange(event, layer.id, 'bottom')}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    type="number"
                    value={layer.top}
                    onChange={(event) => this.handleInputChange(event, layer.id, 'top')}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    value={layer.strength}
                    onChange={(event) => this.handleInputChange(event, layer.id, 'C-profil')}
                  />
                </TableCell>
                
                <TableCell>
                  <TextField
                    type="number"
                    value={layer.frictionAngle}
                    onChange={(event) => this.handleInputChange(event, layer.id, 'Su[kPa]')}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    type="number"
                    value={layer.frictionAngle}
                    onChange={(event) => this.handleInputChange(event, layer.id, 'Friksjonsvinkel')}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    type="number"
                    value={layer.frictionAngle}
                    onChange={(event) => this.handleInputChange(event, layer.id, 'E-modul')}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
}

export default LayerDataTable;
